import { COMPANY_NAME } from 'config/portal'

export const PAYMENT_CONFIRMATION_TEXT = `I authorize ${COMPANY_NAME.medium} to charge the credit card listed above for the amount of 
the total payment due for notification services. I certify that I am an authorized cardholder or user of the credit card, the credit 
card is valid, and information provided is true and accurate.  I acknowledge that this charge will appear on the credit card statement 
as ${COMPANY_NAME.medium}.`

export const NotificationStatuses = {
  IN_PROGRESS: 'In progress',
  SENT: 'Sent',
  DELIVERED: 'Delivered',
  RETURN: 'Return to sender',
  NOT_DELIVERED: 'Not delivered',
}
